module.exports = __webpack_public_path__ + "static/media/logo_PPLUS.e6d415c1.jpg";